import { render, staticRenderFns } from "./TeamDashboard.vue?vue&type=template&id=19c4610b&scoped=true&"
import script from "./TeamDashboard.vue?vue&type=script&lang=js&"
export * from "./TeamDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeamDashboard.vue?vue&type=style&index=0&id=19c4610b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4610b",
  null
  
)

export default component.exports